export const subRoutes = {
  PROFILE: '/profile',
  PASSWORD: '/password',
  ADMIN: '/admin',
};
